<template>
    <div ref="sentinelRef" />
    <Transition
        v-if="isMounted"
        :enterFromClass="$style.fade_enter_from"
        :enterActiveClass="$style.fade_enter_active"
        :leaveActiveClass="$style.fade_leave_active"
        :leaveToClass="$style.fade_leave_to"
        appear
    >
        <div
            v-if="isBannerVisible"
            :class="$style.banner"
        >
            <AdContainer
                placement="sticky_desktop"
                backdrop
            >
                <template #default="{ isVisible }">
                    <button
                        v-if="isVisible && isStickyMode"
                        :class="$style.close_button"
                        data-interface-target="close-sticky-desktop-banner"
                        @click="onClose"
                    >
                        <Icon
                            name="close"
                            :alt="$tr('desktopStickyBanner.closeButtonLabel')"
                            :class="$style.close_icon"
                        />
                    </button>
                </template>
            </AdContainer>
        </div>
    </Transition>
</template>

<script setup lang="ts">
import { useIntersectionObserver } from '@vueuse/core'
import { ref } from 'vue'

import AdContainer from '@/components/AdContainer/AdContainer.vue'
import Icon from '@/components/Icon/Icon.vue'
import { useLoggerStore } from '@/store/logger'
import { useIsMounted } from '@/utils/vue-hooks/use-is-mounted'

const loggerStore = useLoggerStore()
const isMounted = useIsMounted()

const isBannerVisible = ref(true)
const isStickyMode = ref(true)

const sentinelRef = ref<HTMLDivElement>()

function onClose() {
    loggerStore.logEvent({
        event: 'custom_event',
        eventName: 'ad_close',
        adPlacement: 'sticky_desktop',
    })
    isBannerVisible.value = false
}

useIntersectionObserver(sentinelRef, (entries) => {
    isStickyMode.value = !entries[0]?.isIntersecting
})
</script>

<style module>
.banner {
    position: sticky;
    bottom: 0;
    z-index: 1;
}

.close_button {
    position: absolute;
    top: -26px;
    right: 0;
    padding: 0;
    background: transparent;
    cursor: pointer;
    pointer-events: auto;
    transition: filter 0.2s;
}

.close_button:hover {
    filter: brightness(0.9);
}

.close_icon {
    width: 24px;
    height: 24px;
    background: white;
    backdrop-filter: blur(20px);
    border-radius: 1000px;
    color: rgba(0, 0, 0, 0.5);
}

.fade_enter_active,
.fade_leave_active {
    transition: all 0.8s ease;
}

.fade_enter_from,
.fade_leave_to {
    transform: translateY(300px);
}
</style>
